import type { AppEvent, AppTypestate } from '@/lib/machines/app-state-machine';
import { type MyMachineContext, appStateMachine } from '@/lib/machines/app-state-machine';
import { useMachine } from '@xstate/react';
import type { ReactNode } from 'react';
import React, { createContext, useContext } from 'react';
import type { Interpreter, State } from 'xstate';

interface MyMachineContextProps {
    state: State<MyMachineContext, AppEvent, any, AppTypestate, any>;
    send: Interpreter<MyMachineContext, any, AppEvent, AppTypestate, any>['send'];
}

// Your context creation remains the same
const MyMachineContext = createContext<MyMachineContextProps | null>(null);

// Your provider props
interface AppStateMachineProviderProps {
    children: ReactNode;
}

export const AppStateMachineProvider: React.FC<AppStateMachineProviderProps> = ({ children }) => {
    const [state, send] = useMachine(appStateMachine);
    return <MyMachineContext.Provider value={{ state, send }}>{children}</MyMachineContext.Provider>;
};

// Your custom hook
export const useAppStateMachine = (): MyMachineContextProps => {
    const context = useContext(MyMachineContext);
    if (!context) {
        throw new Error('useAppStateMachine must be used within a AppStateMachineProvider');
    }
    return context;
};
